import * as actionTypes from '../types/savedProducts';

export function loadReadyProducts(payload) {
  return {
    type: actionTypes.LOAD_READY_PRODUCTS,
    payload
  };
}

export function loadReadyProductsSuccess(payload) {
  return {
    type: actionTypes.LOAD_READY_PRODUCTS_SUCCESS,
    payload
  };
}

export function loadReadyProductsFail(payload) {
  return {
    type: actionTypes.LOAD_READY_PRODUCTS_FAIL,
    payload
  };
}

export function setMarkField(payload) {
  return {
    type: actionTypes.SET_MARK,
    payload
  };
}
export function setNormativeDocField(payload) {
  return {
    type: actionTypes.SET_NORMATIVE_DOC,
    payload
  };
}
export function setOperationNumIdField(payload) {
  return {
    type: actionTypes.SET_OPERATION_NUM_ID,
    payload
  };
}
export function setPieceIdField(payload) {
  return {
    type: actionTypes.SET_PIECE_ID,
    payload
  };
}
export function setPieceNumIdField(payload) {
  return {
    type: actionTypes.SET_PIECE_NUM_ID,
    payload
  };
}
export function setProfileSizeField(payload) {
  return {
    type: actionTypes.SET_PROFILE_SIZE,
    payload
  };
}
export function setQcDateField(payload) {
  return {
    type: actionTypes.SET_QC_DATE,
    payload
  };
}
export function setQcIdField(payload) {
  return {
    type: actionTypes.SET_QC_ID,
    payload
  };
}
export function setQtyField(payload) {
  return {
    type: actionTypes.SET_QTY,
    payload
  };
}
export function setThicknessField(payload) {
  return {
    type: actionTypes.SET_THICKNESS,
    payload
  };
}
export function setQuantityField(payload) {
  return {
    type: actionTypes.SET_SAVED_QUANTITY,
    payload
  };
}
export function setZdvlLineIdField(payload) {
  return {
    type: actionTypes.SET_ZDVL_LINE_ID,
    payload
  };
}

export function setZdvlLineNumId(payload) {
  return {
    type: actionTypes.SET_ZDVL_LINE_NUM_ID,
    payload
  };
}

export function setLengthField(payload) {
  return {
    type: actionTypes.SET_LENGTH,
    payload
  };
}

export function getSavedProducts(payload) {
  return {
    type: actionTypes.GET_SAVED_PRODUCTS,
    payload
  };
}

export function getSavedProductsSuccess(payload) {
  return {
    type: actionTypes.GET_SAVED_PRODUCTS_SUCCESS,
    payload
  };
}

export function getSavedProductsFail(payload) {
  return {
    type: actionTypes.GET_SAVED_PRODUCTS_FAIL,
    payload
  };
}

export function saveReadyProducts(payload) {
  return {
    type: actionTypes.SAVE_READY_PRODUCTS,
    payload
  };
}

export function saveReadyProductsSuccess(payload) {
  return {
    type: actionTypes.SAVE_READY_PRODUCTS_SUCCESS,
    payload
  };
}

export function saveReadyProductsFail(payload) {
  return {
    type: actionTypes.SAVE_READY_PRODUCTS_FAIL,
    payload
  };
}

export function getReadyProductsBySemi(payload) {
  return {
    type: actionTypes.GET_READY_BY_SEMI,
    payload
  };
}

export function getReadyProductsBySemiSuccess(payload) {
  return {
    type: actionTypes.GET_READY_BY_SEMI_SUCCESS,
    payload
  };
}

export function getReadyProductsBySemiFail(payload) {
  return {
    type: actionTypes.GET_READY_BY_SEMI_FAIL,
    payload
  };
}

export function setReadyProductsPieces(payload) {
  return {
    type: actionTypes.SET_READY_PRODUCTS_PIECES,
    payload
  };
}

export function setQuantityOff(payload) {
  return {
    type: actionTypes.SET_SAVED_QUANTITY_OFF,
    payload
  };
}

export function getZdvlByTask(payload) {
  return {
    type: actionTypes.GET_ZDVL_BY_TASK,
    payload
  };
}

export function getZdvlByTaskSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_BY_TASK_SUCCESS,
    payload
  };
}

export function getZdvlByTaskFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_BY_TASK_FAIL,
    payload
  };
}

export function setCapacityPipe(payload) {
  return {
    type: actionTypes.SET_CAPACITY_PIPE,
    payload
  };
}

export function setCapacityAvailable(payload) {
  return {
    type: actionTypes.SET_CAPACITY_AVAILABLE,
    payload
  };
}
export function setPlantOperationAttribsInherit(payload) {
  return {
    type: actionTypes.SET_ATTRIBS_INHERIT,
    payload
  };
}
export function setProductUnit(payload) {
  return {
    type: actionTypes.SET_UNIT,
    payload
  };
}

export function setSaveRequest(payload) {
  return {
    type: actionTypes.SET_SAVE_REQUEST,
    payload
  }
}
